<script setup>
import Index from "@/views/data/locking/index.vue"

definePage({
  meta: {
    action: 'read',
    subject: 'data-locking',
  },
})
</script>

<template>
  <Index />
</template>
